<script>
export default {
	lang: 'shop',
	computed: {
		product() {
			return this.$parent.$parent.product
		},
		showTemplate() {
			return (
				this.product.info?.templateKey == 'descriptionAndAttrs' && (this.description || this.attrs.length)
			)
		},
		description() {
			return this.product.info?.templateData?.description || this.product.info?.description
		},
		attrs() {
			return this.product.attrs || []
		},
		both() {
			return this.description && this.attrs.length
		},
	},
}
</script>

<template>
	<portal to="Product.info" v-if="showTemplate">
		<Container class="mt-8 mb-16 pa-8">
			<v-row class="flex-md-nowrap flex-column flex-md-row">
				<v-col cols="12" :md="both ? 5 : 12" v-if="attrs.length" order="1" order-md="3">
					<div style="position: sticky; top: 32px">
						<div class="font-2 font-weight-bold pb-4 font-header">{{ 'CARACTERÍSTICAS' | lang }}</div>
						<v-row>
							<v-col cols="6" md="4" v-for="(item, i) of attrs" :key="i">
								<div class="font-weight-bold text-uppercase font-0">
									{{ item.attrKey.k }}
								</div>
								<div class="pt-1">
									{{ item.v }}
								</div>
							</v-col>
						</v-row>
					</div>
				</v-col>
				<v-divider
					:vertical="$vuetify.breakpoint.mdAndUp"
					class="mx-md-4 my-4 my-md-0"
					v-if="both"
					style="order: 2"
				/>
				<v-col cols="12" :md="both ? 7 : 12" v-if="description" order="3" order-md="1">
					<div class="font-2 font-weight-bold pb-4 font-header">
						{{ 'DESCRIPCIÓN' | lang }}
					</div>
					<TruncatedText :text="description" :max-chars="$vuetify.breakpoint.xs ? 300 : 0" />
				</v-col>
			</v-row>
		</Container>
	</portal>
</template>

<style scoped>
.container {
	border-top: 1px solid #ccc;
}
</style>
